// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"35430b7b","453":"ec9a2390"}[chunkId] + ".chunk.js";
};